import $ from 'jquery'
import _ from 'underscore'
import {areUnorderedArraysEqual, arrayToSet, escapeHtmlSymbols} from '../../atUtils'
import messageResource from '../../messageResource'
import {CustomersProjectsSelectionQualifier, DateRangeSelectionQualifier, EvaDateQualifier, LeaveTypeSelectionQualifier} from 'constants'
import ListSelector from '../../controls/ListSelector'
import {ReportChartType} from '../constants'
import {Feature, isEnabled} from '../../features'
import CPReportSelector from '../../cp_selector/cp_selector_report_config'
import {Errors} from './constants'
import SingleDateChartDateRangeSectionStrategy from './SingleDateChartDateRangeSectionStrategy'
import DateRangeChartDateRangeSectionStrategy from './DateRangeChartDateRangeSectionStrategy'
import LeaveHierarchicalSelectorsSectionStrategy from './LeaveHierarchicalSelectorsSectionStrategy'
import BalanceHierarchicalSelectorsSectionStrategy from './BalanceHierarchicalSelectorsSectionStrategy'
import OvertimeHoursHierarchicalSelectorsSectionStrategy from './OvertimeHoursHierarchicalSelectorsSectionStrategy'
import UsersGroupsGroupingLevelSelectorFillingStrategy from './UsersGroupsGroupingLevelSelectorFillingStrategy'
import UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy from './UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy'
import UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy
    from './UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy'
import AllItemsGroupingLevelSelectorFillingStrategy from './AllItemsGroupingLevelSelectorFillingStrategy'
import UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy from './UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy'
import IconWithTooltip from '../../IconWithTooltip'
import OvertimeReportSelectorPanel from '../../usersSelector/at_overtime_report_selector_panel'
import ReportsSelectorUsersPanel from '../at_reports_selector_users_panel'
import ErrorTooltipsForSectionsController from '../ErrorTooltipsForSectionsController'
import ReportUserSelectorButton from '../../controls/ReportUserSelectorButton'
import LeaveTypesSelectorButton from '../../controls/LeaveTypesSelectorButton'
import CustomCheckbox from '../../components/customCheckbox/CustomCheckbox'
import SimpleTooltip from '../../SimpleTooltip'
import BillingChartsHierarchicalSelectorsSectionStrategy from './BillingHierarchicalSelectorsSectionStrategy'
import TaskChartsHierarchicalSelectorsSectionStrategy from './TaskHierarchicalSelectorsSectionStrategy'
import {connect} from '../../redux/utils'
import {getLoggedInUserId} from '../../loggedInUser/selectors'
import StateComponent from '../../StateComponent'
import {userComparator} from '../../usersSelector/user_group_selector_util'
import {formatLFM} from '../../util/UserNameFormat'

class ChartDataParametersSectionController extends StateComponent {
    constructor() {
        super()

        this.state = {
            loggedInUserId: null
        }
    }
}

ChartDataParametersSectionController.prototype.init = function( containerId, chartPopupData, chartType, chartDataParameters, changesCallback )
{
    this.containerId = containerId;
    this.$containerEl = $("#" + this.containerId )

    this.availableCharts = arrayToSet(chartPopupData.availableCharts)
    this.enabledFeatures = chartPopupData.enabledFeatures;
    this.taskChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.taskChartsAuthorizationInfo
    this.balanceChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.balanceChartsAuthorizationInfo
    this.billingChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.billingChartsAuthorizationInfo

    this.customersProjects = chartPopupData.customersProjects;
    this.customersWithMaIds = chartPopupData.customersWithMaIds
    this.projectsWithMaIds = chartPopupData.projectsWithMaIds
    this.users = chartPopupData.users;
    this.userGroups = chartPopupData.userGroups;
    this.timeZoneGroups = chartPopupData.timeZoneGroups;
    this.manageableUsersIds = chartPopupData.manageableUsersIds
    this.leaveTypes = chartPopupData.leaveTypes;

    this.initiallySelectedGroupingLevel = chartDataParameters.groupingLevel;

    this.changesCallback = changesCallback;

    this.dateSelectorContainer = this.getElementBySubId("dateSelector");
    this.singleDateSelectorContainer = this.getElementBySubId("singleDateSelector");
    this.chartTypeListSelectorContainer = this.getElementBySubId("chartTypeListSelectorPlaceholder");
    this.groupingLevelListSelectorContainer = this.getElementBySubId("groupingLevelListSelectorPlaceholder");
    this.$groupingLevelListSelectorRow = this.$containerEl.find(".groupingLevelListSelectorRow");
    this.hierarchicalSelectorsSection = this.getElementBySubId("hierarchicalSelectorsSection");
    this.dateRangeSection = this.getElementBySubId("dateRangeSection");
    this.cpSelectorContainer = this.getElementBySubId("cpSelectorId");
    this.taskUsersSelectorContainer = this.getElementBySubId("taskUserSelectorButtonWrapperId")
    this.billingUsersSelectorContainer = this.getElementBySubId("billingUserSelectorButtonWrapperId")
    this.balanceUsersSelectorContainer = this.getElementBySubId("balanceUserSelectorButtonWrapperId")
    this.overtimeUsersSelectorContainer = this.getElementBySubId("overtimeUserSelectorButtonWrapperId");
    this.withUsernameLabel = this.getElementBySubId("withUsernameLabelId")
    this.leaveTypesSelectorContainer = this.getElementBySubId("leaveTypesSelectorId");
    this.noteMsgContainer = this.getElementBySubId("noteMsgId");
    this.prevUserGroupSelection = {};
    this.prevCpSelection = {};

    this.errorsToSectionElsMap = {}
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_TASK_USER_SELECTION] = $(this.taskUsersSelectorContainer)
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_BALANCE_USER_SELECTION] = $(this.balanceUsersSelectorContainer)
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION] = $(this.billingUsersSelectorContainer)
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION] = $(this.overtimeUsersSelectorContainer)
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_CP_SELECTION] = $(this.cpSelectorContainer)
    this.errorsToSectionElsMap[Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION] = $(this.leaveTypesSelectorContainer)

    this.errorTooltipsForSectionsController = new ErrorTooltipsForSectionsController().init(
        "createChartErrorTooltip",
        this.errorsToSectionElsMap,
        (error) => this.getErrorMessageForSingleError(error),
    )


    const $infoIconWrappers = this.$containerEl.find(".infoIconWrapper");
    _.each($infoIconWrappers, function(wrapper)
    {
        const $wrapper = $(wrapper);
        $wrapper.empty();
        new IconWithTooltip(messageResource.getMessage("report.create_chart.users_wo_data_note")).init($wrapper);
    });

    this.$includeOtherUsersCheckboxPlaceholder = this.$containerEl.find('.includeOtherUsersCheckboxPlaceholder')

    this.setParameters(chartType, chartDataParameters)

    return this;
};

ChartDataParametersSectionController.prototype.setParameters = function(chartType, chartDataParameters) {
    this.deleteOldSelectors();

    this.dateRangeSelector = this.createDateRangeSelector( chartDataParameters );
    this.singleDateSelector = this.createSingleDateSelector( chartDataParameters );
    this.chartTypeSelector = this.createChartTypeSelector( chartType );
    this.groupingLevelSelector = this.createGroupingSelector( chartType, chartDataParameters.groupingLevel );
    this.cpSelector = this.makeCPSelector(chartDataParameters, this.customersProjects, this.customersWithMaIds, this.projectsWithMaIds)

    this.balanceUserSelector = this.makeUserSelector(
        this.balanceUsersSelectorContainer,
        chartDataParameters,
        this._getSortedAvailableUsersByIds(this.balanceChartsAuthorizationInfo.availableUserIds),
        this.userGroups,
        this.timeZoneGroups,
        this.balanceChartsAuthorizationInfo.allUsersAvailable,
    )

    this.billingUserSelector = this.makeUserSelector(
        this.billingUsersSelectorContainer,
        chartDataParameters,
        this._getSortedAvailableUsersByIds(this.billingChartsAuthorizationInfo.availableUserIds),
        this.userGroups,
        this.timeZoneGroups,
        this.billingChartsAuthorizationInfo.allUsersAvailable,
    )

    this.taskUserSelector = this.makeUserSelector(
        this.taskUsersSelectorContainer,
        chartDataParameters,
        this._getSortedAvailableUsersByIds(this.taskChartsAuthorizationInfo.availableUserIds),
        this.userGroups,
        this.timeZoneGroups,
        this.taskChartsAuthorizationInfo.allUsersAvailable,
    )

    this.overtimeUserSelector = this.makeOvertimeUserSelector(
        chartDataParameters,
        this.users.sort(userComparator),
        this.userGroups,
        this.timeZoneGroups,
        this.balanceChartsAuthorizationInfo.allUsersAvailable
    )

    this.leaveTypesSelector = this.makeLeaveTypesSelector( chartDataParameters, this.leaveTypes );
    this.includeOtherUsersCheckbox = this.makeIncludeOtherUsersCheckbox(chartDataParameters);

    this.dateRangeSectionStrategy = this.getDateRangeSectionStrategy( chartType );
    this.hierarchicalSelectorsSectionStrategy = this.getHierarchicalSelectorsSectionStrategy( chartType );

    this.errors = [];

    this.updateUI();
}

ChartDataParametersSectionController.prototype.DEFAULT_SELECTOR_PARAMETERS = {
    dateRangeSelection: {
        qualifier: DateRangeSelectionQualifier.CURRENT_MONTH,
        fromDate: null,
        toDate: null
    },
    singleDateSelection: {
        qualifier: EvaDateQualifier.TODAY,
        date: null
    },
    cpSelection: {
        qualifier: CustomersProjectsSelectionQualifier.ALL,
        customers: [],
        projects: [],
        showArchivedProjects: false
    },
    userSelection: {
        allUsers: true,
        selectedUsers: [],
        selectedGroups: [],
        showDisabled: false
    },
    leavesSelection: {
        qualifier: LeaveTypeSelectionQualifier.ALL,
        leaveTypes: [],
        showInactive: false
    }
};

ChartDataParametersSectionController.prototype.onChartTypeChanged = function()
{
    const newChartType = this.chartTypeSelector.getSelectedItem().value;
    this.hierarchicalSelectorsSectionStrategy = this.getHierarchicalSelectorsSectionStrategy( newChartType );
    this.prevUserGroupSelection = this.hierarchicalSelectorsSectionStrategy.getUserSelection()
    // To save selection while chart type changes - need to be fixed or remove
    // const oldUserSelection = this.hierarchicalSelectorsSectionStrategy.getUserSelection()
    // const userSelected = this.hierarchicalSelectorsSectionStrategy.validateIsUserSelected()
    // const withUserSelector = this.hierarchicalSelectorsSectionStrategy.withUserSelector()
    // this.hierarchicalSelectorsSectionStrategy.setUserSelection(withUserSelector && userSelected ? oldUserSelection : this.DEFAULT_SELECTOR_PARAMETERS.userSelection)
    this.handleWaMaCpSelectorScope(newChartType)
    this.dateRangeSectionStrategy = this.getDateRangeSectionStrategy( newChartType );
    const oldSelectedGroupingLevel = this.groupingLevelSelector.getSelectedItem().value;
    $( this.groupingLevelListSelectorContainer ).empty();
    this.groupingLevelSelector = this.createGroupingSelector( newChartType, oldSelectedGroupingLevel );
    this.changesDetected();
};

ChartDataParametersSectionController.prototype.handleWaMaCpSelectorScope = function(chartType) {
    if (this.cpSelector.panel.isAlreadyShown()) {
        switch (chartType) {
            case ReportChartType.TOTAL_WORKING_HOURS:
            case ReportChartType.APPROVED_WORKING_HOURS:
                this.cpSelector.panel.toggleScopeSwitcher(true)
                break
            case ReportChartType.COST_OF_WORK:
            case ReportChartType.BILLABLE_AMOUNTS:
                this.showManageScopeOnly = true
                this.cpSelector.panel.showOnlyManageScope(true)
                this.cpSelector.panel.toggleScopeSwitcher(false)
                break
        }
    }
}

ChartDataParametersSectionController.prototype.changesDetected = function()
{
    this.validate();
    this.updateUI();

    if ( this.changesCallback )
        this.changesCallback();
};

ChartDataParametersSectionController.prototype.updateUI = function()
{
    this.hierarchicalSelectorsSectionStrategy.updateSectionUI();
    this.dateRangeSectionStrategy.updateSectionUI();
    this._updateIncludeOtherUsersCheckbox()
    this._updateUsernameLabel()

    const containerEl = $( "#" + this.containerId );

    Object.values(Errors).forEach(errorClass => containerEl.removeClass(errorClass))

    for (let i = 0; i < this.errors.length; i++)
        containerEl.addClass(this.errors[i])

    this.errorTooltipsForSectionsController.updateTooltips( this.errors );
};

ChartDataParametersSectionController.prototype._updateIncludeOtherUsersCheckbox = function() {
    const disabled = this.hierarchicalSelectorsSectionStrategy.getUserSelection().allUsers !== true
    this.includeOtherUsersCheckbox.setState({
        checked: !disabled && this.includeOtherUsersCheckbox.isChecked(),
        disabled,
        label: this.showUserSelector
               ? messageResource.getMessage('report.common.include_not_assigned_users')
               : messageResource.getMessage('report.common.include_other_users')
    })

    this.includeOtherUsersCheckboxTooltip.setEnabled(disabled)
}

ChartDataParametersSectionController.prototype._updateUsernameLabel = function() {
    let usernameLabelText = ""
    if (!this.showUserSelector) {
        const user = this.users.find(u => u.id === this.state.loggedInUserId)
        usernameLabelText = formatLFM(user.firstName, user.lastName, user.middleName, ", ")
    }
    this.withUsernameLabel.innerText = usernameLabelText
}

ChartDataParametersSectionController.prototype.getElementBySubId = function( id )
{
    return document.getElementById( this.containerId + "_" + id );
};

ChartDataParametersSectionController.prototype.deleteOldSelectors = function() {
    $(this.dateSelectorContainer).empty()
    $(this.singleDateSelectorContainer).empty()
    $(this.chartTypeListSelectorContainer).empty()
    $(this.groupingLevelListSelectorContainer).empty()
    $(this.cpSelectorContainer).empty()
    $(this.taskUsersSelectorContainer).empty()
    $(this.balanceUsersSelectorContainer).empty()
    $(this.billingUsersSelectorContainer).empty()
    $(this.overtimeUsersSelectorContainer).empty()
    $(this.leaveTypesSelectorContainer).empty()
    this.$includeOtherUsersCheckboxPlaceholder.empty()
}

ChartDataParametersSectionController.prototype.createDateRangeSelector = function( chartDataParameters )
{
    const dateRangeSelection = chartDataParameters.dateRangeSelection ? chartDataParameters.dateRangeSelection :
                             this.DEFAULT_SELECTOR_PARAMETERS.dateRangeSelection;

    const self = this;
    const dateRangeSelectorConfig = {
        dateRangeSelection: dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems( dateRangeSelection.qualifier ),
        layout: "auto",
        renderTo: self.dateSelectorContainer.id,
        callOnChangeCallbackIfInvalid: true,
        shortDateFormat: true,
        dropdownClassName: "chartDateDropdown"
    };

    const dateRangeSelector = new DateRangeSelectorController().init( dateRangeSelectorConfig );
    dateRangeSelector._flushErrorState();
    dateRangeSelector.setOnChangeCallback( function() { self.changesDetected(); } );
    return dateRangeSelector;
};

ChartDataParametersSectionController.prototype.createSingleDateSelector = function( chartDataParameters )
{
    const dateSelection = chartDataParameters.dateSelection ? chartDataParameters.dateSelection :
                        this.DEFAULT_SELECTOR_PARAMETERS.singleDateSelection;

    const self = this;
    const dateSelectorConfig = {
        dateRangeSelection: dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        layout: "auto",
        renderTo: self.singleDateSelectorContainer.id,
        shortDateFormat: true
    };

    const dateSelector = new SingleDateSelectorController().init( dateSelectorConfig );
    dateSelector.setOnChangeCallback( function() { self.changesDetected(); } );

    const labelEl = $("<span class='singleDateRangeLabel'>" + messageResource.getMessage("report.create_chart.as_of") + "</span>");
    labelEl.insertBefore( $( this.singleDateSelectorContainer ).find( ".dateRangeDropdownSelector " ) );

    return dateSelector;
};

ChartDataParametersSectionController.prototype.createChartTypeSelector = function( chartType )
{
    const self = this;
    return this.createListSelector( this.chartTypeListSelectorContainer,
                                    function( listSelector ) { self.fillChartTypeListSelector( listSelector, chartType ); },
                                    "chartTypeListSelector",
                                    chartType,
                                    function() { self.onChartTypeChanged(); } );
};

ChartDataParametersSectionController.prototype.createGroupingSelector = function(chartType, selectedGroupingLevel) {
    this.groupingLevelsSelectorFillingStrategy = this.getGroupingLevelSelectorFillingStrategy(chartType)

    return this.createListSelector(
        this.groupingLevelListSelectorContainer,
        (listSelector) => { this.groupingLevelsSelectorFillingStrategy.fillGroupingLevelListSelector(listSelector) },
        "groupingLevelListSelector",
        selectedGroupingLevel,
        () => { this.changesDetected() })
}

ChartDataParametersSectionController.prototype.createListSelector = function( containerEl, fillSelectorCallback, selectorCls,
                                                                              selectedValue, changesCallback )
{
    const listSelector = new ListSelector({
                                            renderTo: containerEl,
                                            menuCls: selectorCls
                                        });
    fillSelectorCallback( listSelector );
    if ( selectedValue )
        listSelector.setActiveItemByValue( selectedValue, true );

    if ( listSelector.getSelectedItem() === null )
        listSelector.setItem( listSelector.menu.items.items[0] );

    listSelector.on( "change", function () {
        if ( changesCallback )
            changesCallback();
    });

    return listSelector;
};

ChartDataParametersSectionController.prototype.fillChartTypeListSelector = function(listSelector, chartType) {
    const taskCharts = []
    if (this.availableCharts[ReportChartType.TOTAL_WORKING_HOURS])
        taskCharts.push({text: messageResource.getMessage("report.chart_type.total_working_hours"), value: ReportChartType.TOTAL_WORKING_HOURS})
    if (this.availableCharts[ReportChartType.APPROVED_WORKING_HOURS] || chartType === ReportChartType.APPROVED_WORKING_HOURS)
        taskCharts.push({text: messageResource.getMessage("report.chart_type.approved_working_hours"), value: ReportChartType.APPROVED_WORKING_HOURS})

    const timeCharts = []
    if (this.availableCharts[ReportChartType.LEAVE_HOURS] || chartType === ReportChartType.LEAVE_HOURS)
        timeCharts.push({text: messageResource.getMessage("report.chart_type.leave_hours"), value: ReportChartType.LEAVE_HOURS})
    if (this.availableCharts[ReportChartType.PTO_BALANCE] || chartType === ReportChartType.PTO_BALANCE)
        timeCharts.push({text: messageResource.getMessage("report.chart_type.pto_balance"), value: ReportChartType.PTO_BALANCE})
    if (this.availableCharts[ReportChartType.SICK_DAYS_BALANCE] || chartType === ReportChartType.SICK_DAYS_BALANCE)
        timeCharts.push({text: messageResource.getMessage("report.chart_type.sick_days_balance"), value: ReportChartType.SICK_DAYS_BALANCE})
    if (this.availableCharts[ReportChartType.OVERTIME_HOURS] || chartType === ReportChartType.OVERTIME_HOURS)
        timeCharts.push({text: messageResource.getMessage("report.chart_type.overtime_hours"), value: ReportChartType.OVERTIME_HOURS})

    const moneyCharts = []
    if (this.availableCharts[ReportChartType.COST_OF_WORK] || chartType === ReportChartType.COST_OF_WORK)
        moneyCharts.push({text: messageResource.getMessage("report.chart_type.cost_of_work"), value: ReportChartType.COST_OF_WORK})
    if (this.availableCharts[ReportChartType.BILLABLE_AMOUNTS] || chartType === ReportChartType.BILLABLE_AMOUNTS)
        moneyCharts.push({text: messageResource.getMessage("report.chart_type.billable_amounts"), value: ReportChartType.BILLABLE_AMOUNTS})

    if (taskCharts.length > 0) {
        listSelector.addItems(taskCharts)
        if (timeCharts.length > 0 || moneyCharts.length > 0)
            listSelector.addSeparator()
    }

    if (timeCharts.length > 0) {
        listSelector.addItems(timeCharts)
        if (moneyCharts.length > 0)
            listSelector.addSeparator()
    }

    if (moneyCharts.length > 0) {
        listSelector.addItems(moneyCharts)
    }
}

ChartDataParametersSectionController.prototype.isEnabledFeature = function( featureName )
{
    return this.enabledFeatures.hasOwnProperty( featureName );
};

ChartDataParametersSectionController.prototype.getDateRangeSectionStrategy = function( selectedValueType )
{
    if ( selectedValueType === ReportChartType.PTO_BALANCE || selectedValueType === ReportChartType.SICK_DAYS_BALANCE )
        return new SingleDateChartDateRangeSectionStrategy().init( this.dateRangeSection, this.dateRangeSelector, this.singleDateSelector );

    return new DateRangeChartDateRangeSectionStrategy().init( this.dateRangeSection, this.dateRangeSelector, this.singleDateSelector );
};

ChartDataParametersSectionController.prototype.getHierarchicalSelectorsSectionStrategy = function( selectedValueType )
{
    let strategy;
    let showUserSelector = false

    switch ( selectedValueType )
    {
        case ReportChartType.TOTAL_WORKING_HOURS:
        case ReportChartType.APPROVED_WORKING_HOURS:
            showUserSelector = this.taskChartsAuthorizationInfo.anyOtherUsersAvailable || this.taskChartsAuthorizationInfo.allUsersAvailable

            strategy = new TaskChartsHierarchicalSelectorsSectionStrategy({
                showUserSelector,
                showIncludeOtherUsersCheckbox: !this.taskChartsAuthorizationInfo.allUsersAvailable,
                taskUserSelector: this.taskUserSelector,
            })
            break;

        case ReportChartType.COST_OF_WORK:
            showUserSelector = this.billingChartsAuthorizationInfo.anyOtherUsersAvailable || this.billingChartsAuthorizationInfo.allUsersAvailable

            strategy = new BillingChartsHierarchicalSelectorsSectionStrategy({
                showUserSelector,
                showIncludeOtherUsersCheckbox: !this.billingChartsAuthorizationInfo.allUsersAvailable,
                billingUserSelector: this.billingUserSelector,
            });
            break;

        case ReportChartType.BILLABLE_AMOUNTS:
            showUserSelector = true

            strategy = new BillingChartsHierarchicalSelectorsSectionStrategy({
                showUserSelector: showUserSelector,
                showIncludeOtherUsersCheckbox: !this.billingChartsAuthorizationInfo.allUsersAvailable,
                billingUserSelector: this.billingUserSelector,
            });
            break;

        case ReportChartType.LEAVE_HOURS:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable

            strategy = new LeaveHierarchicalSelectorsSectionStrategy({
                showUserSelector: showUserSelector,
                balanceUserSelector: this.balanceUserSelector,
            })
            break

        case ReportChartType.PTO_BALANCE:
        case ReportChartType.SICK_DAYS_BALANCE:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable
            strategy = new BalanceHierarchicalSelectorsSectionStrategy({
                showUserSelector: showUserSelector,
                balanceUserSelector: this.balanceUserSelector,
            })
            break;

        case ReportChartType.OVERTIME_HOURS:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable
            strategy = new OvertimeHoursHierarchicalSelectorsSectionStrategy({
                showUserSelector: showUserSelector,
                overtimeUserSelector: this.overtimeUserSelector,
            });
            break;

        default:
            throw "Incorrect report chart type";
    }

    this.showUserSelector = showUserSelector

    strategy.init({
        container: this.hierarchicalSelectorsSection,
        leaveTypesSelector: this.leaveTypesSelector,
        noteMsgContainer: this.noteMsgContainer,
        includeOtherUsersCheckbox: this.includeOtherUsersCheckbox,
        cpSelector: this.cpSelector,
    })

    return strategy
};

ChartDataParametersSectionController.prototype._getSortedAvailableUsersByIds = function(userIds) {
    const idsSet = arrayToSet(userIds)
    return this.users.filter(user => idsSet[user.id]).sort(userComparator)
}


ChartDataParametersSectionController.prototype.getGroupingLevelSelectorFillingStrategy = function(selectedChartType) {
    const ugrEnabled = isEnabled(Feature.UGR)
    const tzgEnabled = isEnabled(Feature.TZG)
    const btyEnabled = isEnabled(Feature.BTY)

    if (selectedChartType === ReportChartType.PTO_BALANCE || selectedChartType === ReportChartType.SICK_DAYS_BALANCE) {
        return new UsersGroupsGroupingLevelSelectorFillingStrategy().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel)
    }
    else if (selectedChartType === ReportChartType.OVERTIME_HOURS) {
        return new UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel)
    }
    else if (selectedChartType === ReportChartType.LEAVE_HOURS) {
        return new UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy().init(ugrEnabled, btyEnabled, tzgEnabled,
            this.initiallySelectedGroupingLevel)
    }
    else if (selectedChartType === ReportChartType.TOTAL_WORKING_HOURS || selectedChartType === ReportChartType.APPROVED_WORKING_HOURS) {
        return new AllItemsGroupingLevelSelectorFillingStrategy().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel)
    }
    else {
        return new UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel)
    }
}

ChartDataParametersSectionController.prototype.makeCPSelector = function (chartDataParameters, cpList, customersWithMaIds, projectsWithMaIds)
{
    const cpSelection = chartDataParameters.customersProjectsSelection ? chartDataParameters.customersProjectsSelection :
                      this.DEFAULT_SELECTOR_PARAMETERS.cpSelection;

    const cpSelector = new CPReportSelector().init(
        cpSelection,
        this.cpSelectorContainer.id,
        () => {
            const currentSelection = cpSelector.getCpSelection()
            if (this.cpSelector.panel.shouldSave && !_.isEqual(currentSelection, this.prevCpSelection)) {
                this.changesDetected()
                this.cpSelector.setInitialValueFromCurrent()
                this.prevCpSelection = currentSelection
            }
        },
        true,
        () => this.handleWaMaCpSelectorScope(this.chartTypeSelector.getSelectedItem().value),
    )

    this.showManageScopeOnly = false
    this.prevCpSelection = cpSelection
    cpSelector.initializeData( cpList, customersWithMaIds, projectsWithMaIds );
    return cpSelector;
};

ChartDataParametersSectionController.prototype.makeUserSelector = function(usersSelectorContainer, chartDataParameters, users, userGroups, timeZoneGroups, allUsersAvailable) {
    return this.createUserSelector(
        usersSelectorContainer,
        chartDataParameters,
        users,
        userGroups,
        timeZoneGroups,
        ReportsSelectorUsersPanel,
        allUsersAvailable,
        this.manageableUsersIds
    )
}

ChartDataParametersSectionController.prototype.makeOvertimeUserSelector = function(chartDataParameters, users, userGroups, timeZoneGroups, allUsersAvailable) {
    const overtimeUsers = []
    const manageableOvertimeUsersIds = []
    const manageableIdsSet = this.manageableUsersIds != null ? arrayToSet(this.manageableUsersIds) : null

    for (let i = 0; i < users.length; i++) {
        if (users[i].overtimeEnabled) {
            overtimeUsers.push(users[i])

            if (manageableIdsSet == null || manageableIdsSet[users[i].id]) {
                manageableOvertimeUsersIds.push(users[i].id)
            }
        }
    }

    return this.createUserSelector(
        this.overtimeUsersSelectorContainer,
        chartDataParameters,
        overtimeUsers,
        userGroups,
        timeZoneGroups,
        OvertimeReportSelectorPanel,
        allUsersAvailable,
        manageableOvertimeUsersIds
    )
}

ChartDataParametersSectionController.prototype.createUserSelector = function (
    selectorContainer,
    chartDataParameters,
    users,
    userGroups,
    timeZoneGroups,
    panelConstructor,
    allUsersAvailable,
    manageableUsersIds,
) {
    const defaultUserSelection = {
        allUsers: true,
        selectedUsers: [],
        selectedGroups: [],
        showDisabled: false,
        groupType: null,
        includeUserTeamOnly: false
    };
    const userSelection = chartDataParameters.userSelection ? chartDataParameters.userSelection : defaultUserSelection;

    const userSelector = new ReportUserSelectorButton();

    const selectorConfig = {
        selectorId: selectorContainer.id,
        userSelection: userSelection,
        specificConstructorPanel: panelConstructor,
        changeCallback: () => {
            const currentSelection = userSelector.getSelection()
            if (userSelector.panel.shouldSave && !_.isEqual(currentSelection, this.prevUserGroupSelection)) {
                this.changesDetected()
                userSelector.setInitialValueFromCurrent()
                this.prevUserGroupSelection = currentSelection
            }
        },
        withApplyButton: true,
        needAdditionalCheckbox: false,
        includeUsersWithoutDataDefaultValue: true,
        allUsersAvailable,
    };

    userSelector.init(selectorConfig);
    userSelector.updateSelector(
        users,
        userGroups,
        timeZoneGroups,
        manageableUsersIds,
        userSelection.includeUserTeamOnly
    );

    userSelector.panel.loggedInUserNotInTeam = this.manageableUsersIds !== null
                                               && this.manageableUsersIds.indexOf(this.state.loggedInUserId) === -1
                                               && users.some(u => u.id === this.state.loggedInUserId)

    userSelector.updateButton()

    this.prevUserGroupSelection = userSelection

    return userSelector;
};

ChartDataParametersSectionController.prototype.makeIncludeOtherUsersCheckbox = function(chartDataParameters) {
    this.includeOtherUsersCheckbox = new CustomCheckbox({
        label: messageResource.getMessage('report.common.include_not_assigned_users'),
        checkboxAdditionalClass: 'checkboxInput',
        checkmarkAdditionalClass: 'hiddenCheckmark',
        checked: chartDataParameters.includeOtherUsersColumn,
        onChange: () => this.changesDetected()
    }).init(this.$includeOtherUsersCheckboxPlaceholder)

    this.includeOtherUsersCheckboxTooltip = new SimpleTooltip({
        text: messageResource.getMessage('report.common.show_other_users_checkbox_tooltip_text'),
    }).init($('body'))
    this.includeOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.includeOtherUsersCheckbox.getEl())

    return this.includeOtherUsersCheckbox
}

ChartDataParametersSectionController.prototype.includeOtherUsers = function() {
    if (this.hierarchicalSelectorsSectionStrategy.isShowIncludeOtherUsersCheckbox())
        return this.includeOtherUsersCheckbox.isChecked()
    return false
}

ChartDataParametersSectionController.prototype.isStateChanged = function(currentSelectionData, previousSelectionData) {

    if (currentSelectionData.optionValue !== previousSelectionData.optionValue) {
        return true;
    } else {
        if (currentSelectionData.isCustomOptionSelected) {
            return !this.twoLevelSelectionEquals(currentSelectionData.selection, previousSelectionData.selection);
        }
    }
    return false;
}

ChartDataParametersSectionController.prototype.twoLevelSelectionEquals = function(currentSelection, previousSelection) {
    return areUnorderedArraysEqual(currentSelection.getFirstLevel(), previousSelection.getFirstLevel()) &&
           areUnorderedArraysEqual(currentSelection.getSecondLevel(), previousSelection.getSecondLevel());
}

ChartDataParametersSectionController.prototype.makeLeaveTypesSelector = function(chartDataParameters, leavesData) {
    const leavesSelection = chartDataParameters.leaveTypeSelection ? chartDataParameters.leaveTypeSelection :
                          this.DEFAULT_SELECTOR_PARAMETERS.leavesSelection

    const self = this
    return new LeaveTypesSelectorButton().init({
        renderTo: this.leaveTypesSelectorContainer.id,
        leavesSelection,
        leavesData,
        ptoFeatureEnabled: isEnabled(Feature.PTO),
        sickBalanceFeatureEnabled: isEnabled(Feature.SDB),
        changeCallback: function() {
            if (self.leaveTypesSelector.isStateChanged())
                self.changesDetected()
            self.leaveTypesSelector.setInitialValuesFromCurrent()
        },
        withApplyButton: true,
        showInactiveCheckbox: true,
    })
}

ChartDataParametersSectionController.prototype.validate = function()
{
    this.errors = [];

    const dateRangeErrors = this.dateRangeSectionStrategy.validate();
    const hierarchicalSelectorsErrors = this.hierarchicalSelectorsSectionStrategy.validate();

    let i;
    for ( i = 0; i < dateRangeErrors.length; i++ )
        this.errors.push( dateRangeErrors[i] );
    for ( i = 0; i < hierarchicalSelectorsErrors.length; i++ )
        this.errors.push( hierarchicalSelectorsErrors[i] );

    return this.errors.length === 0;
};

ChartDataParametersSectionController.prototype.hasErrors = function()
{
    return this.errors.length !== 0;
};

ChartDataParametersSectionController.prototype.getChartType = function()
{
    return this.chartTypeSelector.getSelectedItem().value;
};

ChartDataParametersSectionController.prototype.getSelectedValues = function ()
{
    return {
        chartTypeValue: this.getChartType(),
        groupingLevelValue: this.getGroupingLevel(),
        dateParameters: this.dateRangeSectionStrategy.getSelectedParams(),
        hierarchicalSelectorsParameters: this.hierarchicalSelectorsSectionStrategy.getSelectedParams()
    };
};

ChartDataParametersSectionController.prototype.getSelectedParams = function()
{
    const params = {
        groupingLevel: this.getGroupingLevel(),
    };
    const hierarchicalParams = this.hierarchicalSelectorsSectionStrategy.getSelectedParams();
    const dateRangeParams = this.dateRangeSectionStrategy.getSelectedParamsJSON();
    return $.extend( $.extend( params, hierarchicalParams ), dateRangeParams);
};

ChartDataParametersSectionController.prototype.getGroupingLevel = function()
{
   return this.groupingLevelSelector.getSelectedItem().value
};


ChartDataParametersSectionController.prototype.getErrorMessage = function()
{
    if ( this.errors.length === 0)
        return "";
    if ( this.errors.length > 1 )
        return messageResource.getMessage("report.js.error.exist_invalid_fields");

    return this.getErrorMessageForSingleError( this.errors[0] );
};

ChartDataParametersSectionController.prototype.getErrorMessageForSingleError = function( error )
{
    return escapeHtmlSymbols(this.getUnescapedErrorMessageForSingleError(error))
};

ChartDataParametersSectionController.prototype.getUnescapedErrorMessage = function()
{
    if ( this.errors.length === 0)
        return "";
    if ( this.errors.length > 1 )
        return messageResource.getMessage("report.js.error.exist_invalid_fields");

    return this.getUnescapedErrorMessageForSingleError( this.errors[0] );
};

ChartDataParametersSectionController.prototype.getUnescapedErrorMessageForSingleError = function( error )
{
    switch (error)
    {
        case Errors.ERROR_EMPTY_CP_SELECTION:
            return messageResource.getMessage("projects_customers_selector.please_select_customer_or_project");
        case Errors.ERROR_EMPTY_TASK_USER_SELECTION:
        case Errors.ERROR_EMPTY_BALANCE_USER_SELECTION:
        case Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION:
        case Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION:
            return messageResource.getMessage("report.js.choose_person");
        case Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION:
            return messageResource.getMessage("report.leaves.js.choose_leave_type");
        case Errors.ERROR_INCORRECT_DATE_RANGE:
            return messageResource.getMessage( this.dateRangeSelector.getErrorMessageKey() );
    }
    return "";
};

export default connect(
    state => ({
        loggedInUserId: getLoggedInUserId(state),
    })
)(ChartDataParametersSectionController)



// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartDataParametersSectionController.js